import {
    STATUS_INITIAL, STATUS_PROCESSING, STATUS_SHIPPED,
    STATUS_SHIPMENT_IN_TRANSIT, STATUS_SHIPMENT_OUT_FOR_DELIVERY,
    STATUS_SHIPMENT_WITH_INCIDENT, STATUS_SHIPMENT_DELIVERED,
    STATUS_SHIPMENT_TO_BE_SELF_COLLECTED, STATUS_RETURNING,
    STATUS_SHIPMENT_CANCELED, STATUS_SHIPMENT_RETURNED, STATUS_SHIPMENT_COLLECTED,
    STATUS_ERROR, STATUS_HOLD, STATUS_BACKORDER, STATUS_UNPAID,
    STATUS_RETURNED, STATUS_RETURN_ARRIVED, STATUS_PENDING, STATUS_CANCELED,
    STATUS_INTERRUPTED, STATUS_ENTIRELY_DROPSHIPPING, STATUS_SHIPMENT_PARTIALLY_DELIVERED,
} from '../constants/orderStatuses'

// Per-package / shipment badge classes (Resumen card + tabs). `preparing` is the
// pre-carrier bucket (see packageStatus.derivePackageBadgeStatus).
const BADGE_CLASSES = {
    preparing: 'bg-gray-100 text-gray-600',
    shipment_created: 'bg-gray-100 text-gray-600',
    awaiting_collection: 'bg-gray-100 text-gray-600',
    shipment_not_defined: 'bg-gray-100 text-gray-600',
    shipment_collected: 'bg-blue-100 text-blue-700',
    shipment_in_transit: 'bg-blue-100 text-blue-700',
    shipment_out_for_delivery: 'bg-blue-100 text-blue-700',
    shipment_to_be_self_collected: 'bg-yellow-100 text-yellow-700',
    shipment_with_incident: 'bg-orange-100 text-orange-700',
    shipment_delivered: 'bg-green-100 text-green-700',
    shipment_returned: 'bg-red-100 text-red-700',
    shipment_canceled: 'bg-red-100 text-red-700',
}
const BADGE_FALLBACK = 'bg-gray-100 text-gray-600'

const DOT_CLASSES = {
    preparing: 'bg-gray-400',
    shipment_created: 'bg-gray-400',
    awaiting_collection: 'bg-gray-400',
    shipment_not_defined: 'bg-gray-300',
    shipment_collected: 'bg-blue-400',
    shipment_in_transit: 'bg-blue-500',
    shipment_out_for_delivery: 'bg-blue-500',
    shipment_to_be_self_collected: 'bg-yellow-500',
    shipment_with_incident: 'bg-orange-500',
    shipment_delivered: 'bg-green-500',
    shipment_returned: 'bg-red-500',
    shipment_canceled: 'bg-red-500',
}
const DOT_FALLBACK = 'bg-gray-300'

const AGGREGATE_BADGE = {
    delivered: 'bg-green-100 text-green-700',
    partially_delivered: 'bg-yellow-100 text-yellow-700',
    on_the_way: 'bg-blue-100 text-blue-700',
    packed: 'bg-gray-100 text-gray-600',
    returned: 'bg-red-100 text-red-700',
    canceled: 'bg-red-100 text-red-700',
}

export const statusBadgeClass = (status) => BADGE_CLASSES[status] || BADGE_FALLBACK
export const statusDotClass = (status) => DOT_CLASSES[status] || DOT_FALLBACK
export const aggregateBadgeClass = (key) => AGGREGATE_BADGE[key] || BADGE_FALLBACK

// Semantic color name per ORDER lifecycle status (migrated from ShowOrderContainer).
export const ORDER_STATUS_SEMANTIC_COLOR = {
    [STATUS_INITIAL]: 'green',
    [STATUS_PROCESSING]: 'green',
    [STATUS_SHIPPED]: 'green',
    [STATUS_SHIPMENT_IN_TRANSIT + '_delayed']: 'yellow',
    [STATUS_SHIPMENT_IN_TRANSIT]: 'green',
    [STATUS_SHIPMENT_OUT_FOR_DELIVERY]: 'green',
    [STATUS_SHIPMENT_WITH_INCIDENT]: 'red',
    [STATUS_SHIPMENT_DELIVERED]: 'green',
    [STATUS_SHIPMENT_TO_BE_SELF_COLLECTED]: 'green',
    [STATUS_RETURNING]: 'green',
    [STATUS_SHIPMENT_CANCELED]: 'red',
    [STATUS_SHIPMENT_RETURNED]: 'red',
    [STATUS_SHIPMENT_COLLECTED]: 'green',
    [STATUS_ERROR]: 'red',
    [STATUS_ERROR + '_delayed']: 'yellow',
    [STATUS_HOLD]: 'yellow',
    [STATUS_BACKORDER]: 'yellow',
    [STATUS_UNPAID]: 'red',
    [STATUS_RETURNED]: 'green',
    [STATUS_RETURN_ARRIVED]: 'green',
    [STATUS_PENDING]: 'green',
    [STATUS_CANCELED]: 'red',
    [STATUS_INTERRUPTED]: 'red',
    [STATUS_ENTIRELY_DROPSHIPPING]: 'yellow',
    [STATUS_SHIPMENT_PARTIALLY_DELIVERED]: 'yellow',
}

export const TIMELINE_TITLE_COLOR = { green: 'text-green-500', red: 'text-red-500', yellow: 'text-yellow-500' }
export const TIMELINE_BORDER_COLOR = { green: 'border-green-500', red: 'border-red-500', yellow: 'border-yellow-500' }
